<template>
	<v-menu
			v-model="menu"
			:close-on-content-click="false"
			offset-x
			bottom
	>
		<template v-slot:activator="{ on, attrs }">
			<v-badge color="green" :content="`${paginator.unread_count}`" :class="classes"></v-badge>
			<v-icon v-bind="attrs" v-on="on">
				mdi-bell-outline
			</v-icon>
		</template>

		<v-card width="580" height="750">
			<v-card-title class="primary" style="color: white;">
        <v-row>
          <v-col cols="6" class="d-flex justify-start align-center">
            Notifications
            <v-badge :content="`${paginator.unread_count}`" class="pl-2" bordered></v-badge>
          </v-col>
          <v-col cols="6" class="d-flex justify-end align-center">
            <v-btn small @click="setIsViewedAllNotifications">
              <v-icon class="mr-2" small>
                mdi-message-check-outline
              </v-icon>
              Mark all as read
            </v-btn>
          </v-col>
        </v-row>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col
							cols="12"
							class="my-3"
							style="height: 600px; overflow-y: auto;"
					>
						<div v-if="paginator.count">
							<v-row v-for="item in notifications" :key="item.id">
								<v-col cols="12">
									<v-card
                      outlined
                      shaped
                      elevation="3"
                      :style="!item.is_viewed ? 'border-color: #1976D2; border-radius: 16px 4px;' : ''"
                  >
										<v-card-title class="py-2">
                      <v-row>
                        <v-col cols="10" class="d-flex align-center">
                         <v-icon :color="item.color" class="mr-2">
                            {{ item.icon }}
                          </v-icon>
                          <h5>
                            {{ item.title }}
                          </h5>
                        </v-col>
                        <v-col cols="2" class="d-flex align-center justify-end">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                  v-if="!item.is_viewed"
                                  class="ml-2 mr-2"
                                  color="black"
                                  @click="setIsViewedNotification(item.id)"
                                  v-bind="attrs"
                                  v-on="on"
                              >
                                mdi-message-check-outline
                              </v-icon>
                            </template>
                            <span>Mark as read</span>
                          </v-tooltip>
                          <v-icon class="ml-2 mr-2" color="black" @click="setIsDeleteNotification(item.id)">
                            mdi-delete
                          </v-icon>
                        </v-col>
                      </v-row>
										</v-card-title>
										<v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <p class="mb-0" align="left">
                            {{ item.main_text }}
                          </p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="4" class="d-flex align-center justify-start">
                          <b>{{ item.created_at }}</b>
                        </v-col>
                        <v-col cols="8" class="d-flex align-center justify-end">
                          <span v-if="item.actions.length > 0">
                            Actions:
                          </span>
                          <div v-for="(action, n) in item.actions" :key="n">
                            <open-link-component
                                v-if="action.button_type==='view_file'"
                                :link="action.view_path"
                            ></open-link-component>
                            <download-component
                                v-if="action.button_type==='download_file'"
                                :link="action.download_path"
                            ></download-component>
                          </div>
                        </v-col>
                      </v-row>
										</v-card-text>
									</v-card>
								</v-col>
							</v-row>
						</div>
						<div v-else>
							<span>There are no notifications</span>
						</div>
					</v-col>
				</v-row>
			</v-card-text>
      <v-card-actions v-if="paginator.count">
        <v-row class="d-flex align-center justify-center">
          <v-col cols="10">
            <v-pagination
                v-model="paginator.current"
                :length="paginator.allPages"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-actions>
		</v-card>
	</v-menu>
</template>

<script>

import {mapGetters} from "vuex";
import DownloadComponent from "@/components/thirdParty/action/DownloadComponent.vue";
import OpenLinkComponent from "@/components/thirdParty/action/OpenLinkComponent.vue";
import {processPaginatorResults} from "@/tools/helpers";

export default {
	name: "AppBarNotificationComponent",
	components: {OpenLinkComponent, DownloadComponent},
	computed: {
		...mapGetters({
      userInfo: 'user/getShortInfo',
      isLoading: 'notification/isLoading',
      notifications: 'notification/notifications'
    }),
	},
	props: {
		classes: {
			type: String,
			default: ''
		}
	},
	data: () => ({
		menu: false,
		wsConnection: null,
    paginator: {
      count: 0,
      unread_count: 0,
			limit: 10,
			current: 1,
			next: null,
			previous: null,
			allPages: 1
		},
	}),
	methods: {
		doInitWebsocket() {
			let wsToken = localStorage.getItem(process.env.VUE_APP_WS_TOKEN_STORAGE_KEY)
			this.wsConnection = new WebSocket(`${process.env.VUE_APP_WEBSOCKET_BACKEND_URL}?token=${wsToken}`)

			this.wsConnection.onopen = () => {
				this.onOpen()
			}

			this.wsConnection.onmessage = (event) => {
				this.onMessage(JSON.parse(event.data))
			}

			this.wsConnection.onclose = () => {
				this.onClose()
				setTimeout(() => {
					this.doInitWebsocket()
				}, 5000)
			}

			this.wsConnection.onerror = (event) => {
				this.onError(event)
			}
		},
		onOpen() {
			console.log("Successfully connected to the echo websocket server...")
			setTimeout(() => {
				this.wsConnection.send(
						JSON.stringify({
							action: 'init',
							payload: {
								user_id: this.userInfo.id,
								module: 'notification'
							}
						})
				)
			}, 1000)
		},
		onMessage(message) {
			switch (message.event) {
				case 'simple_notification':
					this.$toastr.i(message.payload.title, 'New simple notification!')
          this.$store.commit('notification/addNewNotification', {notification: message.payload})
          this.paginator.unread_count += 1
					break
			}
		},
		onClose() {
			console.log("Closed connect to websocket server ...")
		},
		onError(event) {
			console.log('Error', event)
		},
    loadNotifications(page = 1) {
			this.$store.dispatch('notification/getAllNotifications', {
				limit: this.paginator.limit,
				offset: (page - 1) * this.paginator.limit
			})
					.then(response => {
						switch (response.status) {
							case 200:
								this.paginator = processPaginatorResults(page, this.paginator.limit, response.data)
								this.paginator.unread_count = response.data.unread_count
								this.$store.commit('notification/updateNotifications', {results: response.data.results})
								this.$forceUpdate()
								break
						}
					})
					.finally(() => {
						this.$store.commit('notification/setIsLoading', {value: false})
					})
		},
    setIsViewedNotification(pk) {
			this.$store.dispatch('notification/setIsViewedNotifications', pk)
					.then(response => {
						switch (response.status) {
							case 200:
                this.loadNotifications(this.paginator.current)
						}
					})
					.finally(() => {
						this.$store.commit('notification/setIsLoading', {value: false})
					})
		},
    setIsViewedAllNotifications() {
			this.$store.dispatch('notification/setIsViewedAllNotifications')
					.then(response => {
						switch (response.status) {
							case 200:
                this.loadNotifications(this.paginator.current)
						}
					})
					.finally(() => {
						this.$store.commit('notification/setIsLoading', {value: false})
					})
		},
    setIsDeleteNotification(pk) {
			this.$store.dispatch('notification/setIsDeleteNotification', pk)
					.then(response => {
						switch (response.status) {
							case 200:
                this.loadNotifications(this.paginator.current)
						}
					})
					.finally(() => {
						this.$store.commit('notification/setIsLoading', {value: false})
					})
		},
	},
  mounted() {
		this.loadNotifications()
	},
  created() {
		this.doInitWebsocket()
	},
	watch: {
		'paginator.current'(page) {
			this.loadNotifications(page)
		}
	}
}
</script>

<style scoped>
</style>
